module.exports = __webpack_public_path__ + "img/Group 9786.6cf18b52.png";